<template>
  <div id="app" >
    <Header v-on:changePage="setNextPage" v-on:changeLg="setLg" />
    <div class="content">
      <div v-if="error">
        <Alert :message="error" variant="danger" />
      </div>
      <div v-else> 
        <Dispatcher :redirect="redirect" :current="mycurrent" v-on:changePage="setNextPage" />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>

import Alert from './components/Alert.vue'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import Dispatcher from './components/Dispatcher.vue'

export default {
  name: 'app',
  data: () => ({
    mycurrent: "Login",
    redirect: "",
    error: "",
    pageStack: []
  }),
  mounted () {
    if (/*@cc_on!@*/false || !!document.documentMode) {
      this.error = this.$i18n.locale === "fr" ? "INTERNET EXPLORER N'EST PAS SUPPORTÉ. VEUILLEZ UTILISER CHROME, FIREFOX OU MICROSOFT EDGE"
      : "INTERNET EXPLORER IS NOT SUPPORTED. PLEASE USE CHROME, FIREFOX OR MICROSOFT EDGE";
    }
  },
  methods: {
    setNextPage(page) {
      this.mycurrent = page;
    },
    setLg(val) {      
      this.$i18n.locale = val;
    },
  },
  components: {
    Alert,
    Dispatcher,
    Header,
    Footer
  }
}
</script>
